export default "__VITE_ASSET__vHB_ku3A__"